/*
  Favoritos (Zendelaya)

  - Guarda prendas y looks favoritos en este navegador (localStorage, clave "zd-favoritos").
    Con sesión iniciada se guardan también en la cuenta (assets/zendelaya-cuenta.js).
  - Lo quitado se anota en "quitados" (tipo, clave, fecha) para que no reaparezca al unir con otro dispositivo.
  - Las prendas se guardan por color: la misma prenda en dos colores son dos favoritos.
  - Cualquier botón [data-zd-fav] (snippets/zendelaya-fav-boton.liquid) marca o desmarca:
      data-tipo="prenda|look", data-handle, data-color (color inicial), data-nombre, data-imagen, data-url,
      data-dinamico="tarjeta|pdp" si el color puede cambiar (miniaturas de la tarjeta o selector de la página de producto).
  - El corazón del encabezado [data-zd-fav-header] se rellena cuando hay al menos un favorito.
  - Avisa los cambios con el evento "zendelaya:favoritos" (lo usa la página de Favoritos).
*/
(function () {
  if (window.ZendelayaFavoritos) return;

  var CLAVE = 'zd-favoritos';
  var textos = { agregar: 'Agregar a favoritos', quitar: 'Quitar de favoritos' };
  try {
    var cfg = document.getElementById('zd-fav-config');
    if (cfg) {
      var c = JSON.parse(cfg.textContent);
      if (c.agregar) textos.agregar = c.agregar;
      if (c.quitar) textos.quitar = c.quitar;
    }
  } catch (e) {}

  function vacio() { return { v: 1, prendas: [], looks: [], quitados: [] }; }
  function leer() {
    try {
      var d = JSON.parse(localStorage.getItem(CLAVE) || 'null');
      if (d && d.v === 1 && Array.isArray(d.prendas) && Array.isArray(d.looks)) {
        if (!Array.isArray(d.quitados)) d.quitados = [];
        return d;
      }
    } catch (e) {}
    return vacio();
  }
  function guardar(d) {
    d.actualizado = Date.now();
    if (d.quitados.length > 300) d.quitados = d.quitados.slice(0, 300);
    try { localStorage.setItem(CLAVE, JSON.stringify(d)); } catch (e) {}
    sincronizar();
    document.dispatchEvent(new CustomEvent('zendelaya:favoritos', { detail: d }));
  }
  function listaDe(d, tipo) { return tipo === 'look' ? d.looks : d.prendas; }
  function clave(tipo, handle, color) { return tipo === 'look' ? handle : handle + '|' + (color || ''); }
  function claveDe(tipo, x) { return clave(tipo, x.handle, x.color); }
  function anotarQuitado(d, tipo, k) {
    d.quitados = d.quitados.filter(function (q) { return !(q.t === tipo && q.k === k); });
    d.quitados.unshift({ t: tipo, k: k, f: Date.now() });
  }

  /* Color que muestra ahora el botón: miniatura elegida en la tarjeta o color elegido en la página de producto */
  function colorDe(b) {
    var din = b.getAttribute('data-dinamico');
    if (din === 'tarjeta') {
      var card = b.closest('product-card') || b.closest('.product-card');
      var sel = card && card.querySelector('[data-zd-color][aria-pressed="true"]');
      if (sel) return sel.getAttribute('data-zd-color');
    } else if (din === 'pdp') {
      var input = document.querySelector('variant-picker[data-template-product-match="true"] .zd-pick--color input:checked') ||
        document.querySelector('.zd-pick--color input:checked');
      if (input) return input.value;
    }
    return b.getAttribute('data-color') || '';
  }
  /* Una variante del color que muestra el botón (la usa la página de Favoritos para dibujar la tarjeta) */
  function varianteDe(b) {
    if (b.getAttribute('data-dinamico') === 'pdp') {
      var input = document.querySelector('product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]');
      if (input && input.value) return input.value;
    }
    var scope = b.closest('product-card, .product-card, [data-ld-card], [data-zcl-card], .zfav-tarjeta') || b.parentNode;
    var talla = scope && scope.querySelector('[data-variant-id]:not([data-variant-id=""])');
    return talla ? talla.getAttribute('data-variant-id') : (b.getAttribute('data-variante') || '');
  }
  function datosDe(b) {
    return {
      variante: varianteDe(b),
      tipo: b.getAttribute('data-tipo') === 'look' ? 'look' : 'prenda',
      handle: b.getAttribute('data-handle'),
      color: colorDe(b),
      nombre: b.getAttribute('data-nombre'),
      imagen: b.getAttribute('data-imagen'),
      url: b.getAttribute('data-url')
    };
  }

  function alternar(datos) {
    var tipo = datos.tipo === 'look' ? 'look' : 'prenda';
    var k = clave(tipo, datos.handle, datos.color);
    var d = leer(), lista = listaDe(d, tipo);
    var i = -1;
    lista.some(function (x, n) { if (claveDe(tipo, x) === k) { i = n; return true; } return false; });
    if (i > -1) {
      lista.splice(i, 1);
      anotarQuitado(d, tipo, k);
    } else {
      var item = { handle: datos.handle, nombre: datos.nombre || '', imagen: datos.imagen || '', url: datos.url || '', fecha: Date.now() };
      if (tipo === 'prenda') { item.color = datos.color || ''; item.variante = datos.variante || ''; }
      lista.unshift(item);
    }
    guardar(d);
    return i === -1;
  }
  function quitar(tipo, handle, color) {
    tipo = tipo === 'look' ? 'look' : 'prenda';
    var k = clave(tipo, handle, color);
    var d = leer(), lista = listaDe(d, tipo);
    var antes = lista.length;
    for (var n = lista.length - 1; n >= 0; n--) if (claveDe(tipo, lista[n]) === k) lista.splice(n, 1);
    if (lista.length !== antes) {
      anotarQuitado(d, tipo, k);
      guardar(d);
    }
  }

  /* Refleja el estado en todos los corazones de la página (sin tocar el DOM si no cambia nada) */
  function sincronizar() {
    var d = leer();
    var marcados = {};
    d.prendas.forEach(function (x) { marcados['prenda:' + claveDe('prenda', x)] = true; });
    d.looks.forEach(function (x) { marcados['look:' + claveDe('look', x)] = true; });
    document.querySelectorAll('[data-zd-fav]').forEach(function (b) {
      var x = datosDe(b);
      var on = !!marcados[x.tipo + ':' + clave(x.tipo, x.handle, x.color)];
      if ((b.getAttribute('aria-pressed') === 'true') !== on) {
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-label', on ? textos.quitar : textos.agregar);
      }
    });
    var hay = d.prendas.length + d.looks.length > 0;
    document.querySelectorAll('[data-zd-fav-header]').forEach(function (a) { a.classList.toggle('is-lleno', hay); });
  }
  var pendiente = null;
  function programar() { clearTimeout(pendiente); pendiente = setTimeout(sincronizar, 80); }

  /* Se captura en window (antes que los enlaces y paneles de las tarjetas) para que el clic no abra el producto */
  window.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-zd-fav]');
    if (!b) {
      /* Cambio de color en una tarjeta o en la página de producto: el corazón refleja ese color */
      if (e.target && e.target.closest && e.target.closest('[data-zd-color], variant-picker, .variant-picker, [data-zd-col-item]')) programar();
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    alternar(datosDe(b));
    b.classList.add('is-latido');
    setTimeout(function () { b.classList.remove('is-latido'); }, 250);
  }, true);
  document.addEventListener('change', programar);

  function iniciar() {
    sincronizar();
    /* Tarjetas que llegan después (recomendaciones, filtros, paginación) y cambios de variante */
    new MutationObserver(function (lista) {
      for (var i = 0; i < lista.length; i++) {
        if (lista[i].addedNodes.length) { programar(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
    /* Cambios hechos en otra pestaña del navegador */
    window.addEventListener('storage', function (e) {
      if (e.key === CLAVE) {
        sincronizar();
        document.dispatchEvent(new CustomEvent('zendelaya:favoritos', { detail: leer() }));
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();

  window.ZendelayaFavoritos = { leer: leer, alternar: alternar, quitar: quitar, sincronizar: sincronizar };
})();
